
import { AxiosResponse } from 'axios';
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { TResponse } from "../../../types/common";
import { IHomePagePayload } from '@src/types/api/homepage';


export async function saveHomePage(data: IHomePagePayload): Promise<AxiosResponse<TResponse<IHomePagePayload>>> {
    return axios.post<TResponse<IHomePagePayload>>(API_ENDPOINTS.SAVE_HOMEPAGE, data)
}

export async function detail(): Promise<AxiosResponse<TResponse<IHomePagePayload>>> {
    return axios.get(`${API_ENDPOINTS.HOMEPAGE_DETAIL}`)
}